module.exports = __webpack_public_path__ + "static/media/process-purple.bf018771.svg";